import { HttpClient } from '@angular/common/http';
import { Api } from '../api';

export class Base {
  protected api: Api;

  constructor(protected httpClient: HttpClient, protected resource: string) {
    this.api = new Api(httpClient, `api/main/v1/${this.resource}`);
  }

  protected get path() {
    return this.api.path;
  }

  protected pathJoin(id: any) {
    return `${this.resource}/${id}`;
  }
}
